import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Input, Space, Table } from 'antd';

const { Search } = Input;

const TagDesktop = ({ viewModel }) => {
  const {
    data,
    filter,
    setFilterValue,
    createTag,
    editTag,
    deleteTag,
  } = viewModel;

  const columns = [
    {
      title: 'Tag',
      render: (_, record) => (
        <Space>
          <div>{record.name}</div>
        </Space>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <Space size='middle'>
          <Button type='link' onClick={() => editTag(record.id)}><EditOutlined /></Button>
          <Button type='link' onClick={() => deleteTag(record.id)}><DeleteOutlined /></Button>
        </Space>
      ),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Card style={{ width: '100%' }}>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Search
            placeholder='Tên hoặc mã'
            onChange={(e) => setFilterValue('info', e.target.value)}
            style={{ width: '100%' }}
            value={filter.info}
          />

          <Flex justify='flex-end' style={{ width: '100%' }}>
            <Button type='primary' onClick={createTag}>Thêm mới</Button>
          </Flex>
        </Space>
      </Card>

      <Card>
        <Table rowKey='id' columns={columns} dataSource={data} />
      </Card>
    </Space>
  );
};

export default TagDesktop;